export default __webpack_public_path__ + "static/media/7fa5aec0b38de102.b13f80ac0825be469f0d8c748b583542.svg";